@let apiResponse = data();
<div class="flex flex-col h-full">
  <div>
    <h1>Opkrævningslister</h1>
  </div>
  <p-tabs
    [(value)]="opkraevningsListerService.activeTab"
    class="flex-1 border-1 overflow-hidden"
  >
    <p-tablist>
      <p-tab value="search"><i class="pi pi-search"></i> Søgning</p-tab>
      @if (apiResponse && apiResponse.data.length > 0) {
      <p-tab value="result"
        ><i class="pi pi-list"></i> Opkrævningslister
      </p-tab>
      } @if (opkraevningsListerService.selectedOpkraevningsListe()) {
      <p-tab value="detail"><i class="pi pi-file"></i> Kørsel</p-tab>
      } @if (opkraevningService.selectedOpkraevning()) {
      <p-tab value="opkraevning"><i class="pi pi-file"></i> Opkrævning</p-tab>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="search">
        <app-opkraevningslister-search />
      </p-tabpanel>
      <p-tabpanel value="result">
        <app-opkraevningslister-result />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-opkraevningslister-detail />
      </p-tabpanel>
      <p-tabpanel value="opkraevning">
        <app-opkraevning-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
